module.exports = __webpack_public_path__ + "static/logo-2-5c61bb263c29caf31d1c6188018cc438.png";